import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/level'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  edit(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  add(level) {
    return http.post(`${resource}`, level)
  },
  update(level, uuid) {
    return http.put(`${resource}/${uuid}`, level)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
